<template>
  <div class="diy-attribute">
    <el-input v-if="type=='input'" v-model="curValue" @input="update"></el-input>
    <el-select v-if="type=='select'" v-model="curValue" @change="update">
      <el-option v-for="(item,index) in option" :key="index" :label="item" :value="item"></el-option>
    </el-select>
    <el-radio-group v-if="type=='radio'" v-model="curValue" @change="update">
      <el-radio v-for="(item,index) in option" :key="index" :label="item">
        {{item}}
      </el-radio>
    </el-radio-group>
    <el-checkbox-group  v-if="type=='checkBox'" v-model="curValue" @change="update">
      <el-checkbox v-for="(item,index) in option" :key="index" :label="item">{{ item }}</el-checkbox>
    </el-checkbox-group>
    <el-date-picker
            @change="update"
            v-if="type=='datePicker'"
            v-model="curValue"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
    </el-date-picker>
    <el-date-picker
            @change="update"
            v-if="type=='dateTimePicker'"
            v-model="curValue"
            type="datetime"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
    </el-date-picker>
    <el-cascader
            @change="update"
            v-if="type=='address'"
            :options="regionData"
            v-model="curValue">
    </el-cascader>
  </div>
</template>

<script>
import { regionData, CodeToText, TextToCode } from 'element-china-area-data'
export default {
  name: 'field',
  props: ['type', 'option', 'value'],
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {
      regionData: regionData,
      curValue: this.value
    }
  },
  watch: {
    value: function (val) {
      if (this.type === 'address') {
        this.curValue[0] = TextToCode[val[0]].code
        this.curValue[1] = TextToCode[val[0]][val[1]].code
        this.curValue[2] = TextToCode[val[0]][val[1]][val[2]].code
      } else {
        this.curValue = val
      }
    }
  },
  /*
  computed: {
    val: {
      // getter
      get: function () {
        return this.value
      },
      // setter
      set: function (newValue) {
        this.curValue = newValue
      }
    }
  },
  */
  methods: {
    update() {
      let value = []
      if (this.type === 'address') {
        value[0] = CodeToText[val[0]]
        value[1] = CodeToText[val[1]]
        value[2] = CodeToText[val[2]]
      } else {
        value = this.curValue
      }
      this.$emit('change', value)
    }
  },
  created() {
    console.log('option', this.option)
  }
}
</script>

<style scoped>
.diy-attribute{text-align: left}
</style>
